import { render, staticRenderFns } from "./EditAddressStock.vue?vue&type=template&id=c50b4f66&"
import script from "./EditAddressStock.vue?vue&type=script&lang=js&"
export * from "./EditAddressStock.vue?vue&type=script&lang=js&"
import style0 from "./EditAddressStock.vue?vue&type=style&index=0&id=c50b4f66&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports